import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { AxiosResponse } from "axios";

interface Props extends DropdownWithoutOptionsProps<server.dto.FreeFieldProfileForList> {
  environment: server.dto.Environments
}

const MoveFreefieldProfilePaginatedDropdown = (props: Props) => {
  const fetchFreefieldProfiles = async (search: string, page: number) => {
    const res = await window.CoreApi.FreeFieldProfile.Paginated({
      keyword: search,
      page,
      perPage: 20,
      environment: props.environment,
      excludeKeys: props.excludeKeys

    });

    return {
      ...res,
      data: {
        ...res.data,
        data: [
          {
            freeFieldProfileId: 0,
            title: RESX.FreeField.PermissionProfileNotSet,
            permissions: undefined,
            freeFieldProfilePermissions: [],
            assignedUsers: [],
            environment: props.environment
          },
          ...res.data.data
        ]
      }
    } satisfies AxiosResponse<server.dto.ApiResponseWrapperWithRequest<server.dto.FreeFieldProfileForList[], server.dto.ListFreeFieldProfileFilters>>;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}

    getLabel={item => RESX.FreeField.SetTheirProfileTo.replace("{0}", item.title)}
    getValue={item => item.freeFieldProfileId}
    onChange={props.onChange}
    value={props.value}
    config={{
      isSearchable: true,
      ...props.config
    }}
    fetchOptions={fetchFreefieldProfiles}
  />;
};

export default MoveFreefieldProfilePaginatedDropdown;